import { useCallback } from 'react';
import './Sources.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { NSCard } from 'bricks';
import { FormikErrors } from 'formik';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import Source from './Source/Source';
import { ISource, ISourcesProps, SourceField } from './Source/types';
import { sourceTypeOptions } from './Source/constants';
import {
    addNewSource, removeSourceById, updateSourceField,
} from './helpers';

const Sources = ({
    totalUses, totalSources, sources, onChange, errors, touched, onBlur,
}: ISourcesProps) => {
    const handleChangeSource = useCallback(
        (id: string, field: SourceField, value: any) => {
            const updatedSources = updateSourceField(sources, id, field, value);
            onChange(updatedSources);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [sources, totalUses, onChange],
    );

    const handleRemoveSource = useCallback(
        (id: string) => {
            const updatedSources = removeSourceById(sources, id);
            onChange(updatedSources);
        },
        [sources, onChange],
    );

    const handleAddSource = useCallback(() => {
        const updatedSources = addNewSource(sources);
        onChange(updatedSources);
    }, [sources, onChange]);

    const handleSourcesBlur = (id: string, field: SourceField) => {
        const sourceIndex = sources.findIndex(source => source.id === id);
        if (sourceIndex > -1) {
            onBlur(sourceIndex, field);
        }
    };

    return (
        <div className="Sources">
            <div className="d-flex align-items-center my-2">
                <div>
                    <div className="Sources__title text-white my-0 font-weight-bold">Sources</div>
                    <div className="Sources__subtitle">Add any information about this investment's sources of funds</div>
                </div>
            </div>

            {sources.map((source, index) => (
                <Source
                    key={source.id}
                    source={source}
                    onChange={handleChangeSource}
                    onRemove={handleRemoveSource}
                    onBlur={handleSourcesBlur}
                    typeOptions={sourceTypeOptions}
                    errors={Array.isArray(errors) && typeof errors[index] === 'object' ? (errors[index] as FormikErrors<ISource>) : undefined}
                    touched={Array.isArray(touched) ? touched[index] : undefined}
                />
            ))}

            <NSButtonBase className="d-flex align-items-center my-2 Sources__add_source" callback={handleAddSource}>
                <FontAwesomeIcon icon={faPlus} />
                <p>Add source</p>
            </NSButtonBase>

            <NSCard className="Sources__total d-flex flex-row align-items-center my-2 Sources__total_row">
                <span className="font-weight-bold text-white">Total sources:</span>
                <span className="font-weight-bold text-white">{numeralFormatterCurrency(totalSources)}</span>
            </NSCard>
        </div>
    );
};

export default Sources;
